import React, { useContext, useState, useEffect } from 'react';

import AppContext from '../../../context';
import { fetchFamilySummary } from '../../../../api';
import { ReactComponent as CoinStackBg } from '../../../../assets/icons/coin-stack-bg.svg';
import { ReactComponent as CoinStack } from '../../../../assets/icons/coin-stack.svg';
import { ReactComponent as SlashDivider } from '../../../../assets/icons/slash-divider.svg';
import { ReactComponent as AngleDownRed } from '../../../../assets/icons/angle-down-red.svg';
import { ReactComponent as AngleUpGreen } from '../../../../assets/icons/angle-up-green.svg';
import { Loader, ErrorBlock, Number } from '../../common/common';
import './family_summary.component.css';

const FamilySummary = (props) => {
  const context = useContext(AppContext);
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const get_data_class = (data) => {
    let color_class = '';
    if (data !== 0) {
      color_class = data < 0 ? 'c-negative negative' : 'c-positive positive';
    }
    return color_class + ' data';
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchFamilySummary();
        setSummary(response.data.data.summary.total);
      } catch (error) {
        setError('Something went wrong');
      }
    };
    setIsLoading(true);
    if (context.resetPf.resetId || context.resetPf.switchId) {
      setTimeout(() => {
        fetchData();
      }, 4200);
    } else {
      fetchData();
    }
  }, [context.resetPf]);

  useEffect(() => {
    if (summary || error) {
      setIsLoading(false);
    }
  }, [summary, error]);

  return isLoading ? (
    <Loader />
  ) : error ? (
    <ErrorBlock />
  ) : (
    <section className="summary_container family bg">
      <div className="net_worth_container">
        <div className="coin_icon">
          <CoinStackBg />
          <div className="coin_stack">
            <CoinStack />
          </div>
        </div>
        <div className="summary-item">
          <div className="head">Net Worth</div>
          <div className="data">
            <Number
              value={summary.unrealised}
              usePrefix={true}
              format={true}
              isFormatWeb={true}
            />
          </div>
        </div>
      </div>
      <div className="gains_container">
        <div className="summary-item gain">
          <div className="head">
            <span className="desktop">Today's</span>
            <span className="mobile">1D</span>
            <span>&nbsp;Gain</span>
          </div>
          <div className={get_data_class(summary.one_day_change)}>
            <Number
              value={summary.one_day_change}
              usePrefix={true}
              format={true}
              isFormatWeb={true}
            />
          </div>
        </div>
        <SlashDivider />
        <div className="summary-item total_gain">
          <div className="head">Total Gain</div>
          <div className={get_data_class(summary.gain_loss)}>
            <div class="text-nowrap">
              <Number
                value={summary.gain_loss}
                usePrefix={true}
                format={true}
                isFormatWeb={true}
              />
            </div>
            <div className="change_perc">
              <div>{summary.gain_loss_abs_perc}%</div>
              <div>
                {summary.gain_loss_abs_perc >= 0 ? (
                  <AngleUpGreen />
                ) : (
                  <AngleDownRed />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FamilySummary;
